import { render, staticRenderFns } from "./LinkReceiptToPO.vue?vue&type=template&id=970bb0ee&"
import script from "./LinkReceiptToPO.vue?vue&type=script&lang=js&"
export * from "./LinkReceiptToPO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports